import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import FrameworkSection from "./components/FrameworkSection";
import ResearchSection from "./components/ResearchSection";
import FounderSection from "./components/FounderSection";
import ContactSection from "./components/ContactSection";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://example.com";

export default function Home() {
  useEffect(() => {
    const id = "jsonld-home";
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement("script");
      el.id = id;
      el.type = "application/ld+json";
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify([
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "CashLearn",
        "url": SITE_URL,
        "description": "CashLearn is a leading financial education platform offering structured learning frameworks, research-backed methodologies, and impactful resources for learners and educators.",
        "potentialAction": {
          "@type": "SearchAction",
          "target": `${SITE_URL}/?q={search_term_string}`,
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@context": "https://schema.org",
        "@type": "EducationalOrganization",
        "name": "CashLearn",
        "url": SITE_URL,
        "logo": "https://storage.readdy-site.link/project_files/fa2855be-6543-46bb-a290-e278f3e02ae4/7026652b-a76e-4e49-b611-ccda7b5f8bf6_Black-Eagle-Company-Business-Group-Logo-1.png?v=09fc30c756d57fb1dd496aae24bfed91",
        "description": "CashLearn provides research-backed financial literacy education frameworks for K–12 students, educators, school districts, and policy organizations across the United States.",
        "foundingDate": "2024",
        "founder": {
          "@type": "Person",
          "name": "Aditi Sanjay Kumar",
          "url": `${SITE_URL}/founder`,
          "sameAs": [
            "https://www.linkedin.com/in/aditi-cc/",
            "https://www.instagram.com/aditi.sanjay.kumar/"
          ]
        },
        "sameAs": [
          "https://www.linkedin.com/in/aditi-cc/",
          "https://www.instagram.com/aditi.sanjay.kumar/"
        ]
      },
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "CashLearn - Financial Education, Learning Framework & Research",
        "url": SITE_URL,
        "description": "CashLearn is a leading financial education platform offering structured learning frameworks, research-backed methodologies, and impactful resources for learners and educators worldwide.",
        "isPartOf": { "@type": "WebSite", "url": SITE_URL },
        "dateModified": "2026-04-14",
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": SITE_URL }
          ]
        }
      }
    ]);
    return () => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#faf7f2]">
      <Navbar />
      <main>
        <HeroSection />
        <FrameworkSection />
        <ResearchSection />
        <FounderSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
